export default __webpack_public_path__ + "static/media/location_on.64e80aaa.svg";